export default {
	STATUS_RETRY_TIMEOUT: -100,
	DRAWIT_SUBMISSION_REQUIRED: -10,
	GENERIC_ERROR: -1,
	MISSING_PARAMS: -2,
	VALIDATION_ERROR: -3,
	TRIM_CHANGE_NOT_SAVED: -4,
	GOOGLE_SLIDES_UNAUTHORIZED_USER: -5,
}
